import React, { useEffect, useState } from 'react';
import { UserType } from '../../..//types';
import formatPhoneNumber from "../../../utils/functions/formatPhoneNumber";
import VPAutoService from "../../../services/VPAuto/VPAutoService";
import { useTranslation } from "react-i18next";
import TextInputMobile from "../atomicDesignMobile/atoms/TextInputMobile";
import SelectInputMobile from "../atomicDesignMobile/atoms/SelectInputMobile";
import toTitleCase from "../../../utils/functions/toTitleCase";
import { useAuthContext } from "../../../contexts/AuthContext";


const SignUpPageMobileProPanel1 = () => {
	const {
		userInfo,
		setUserInfo,
		isFirstPanelValidated,
		validateFirstPanel,
		openedPanel,
		setOpenedPanel
	} = useAuthContext();
	const { t } = useTranslation();
	const [optionsListHowDidYouKnowUs, setOptionsListHowDidYouKnowUs] = useState<{
		value: string,
		label: string
	}[]>([]);
	
	const [wrongFields, setWrongFields] = useState({
		email: false,
		lastName: false,
		firstName: false,
		phone: false,
		function: false,
	});
	
	useEffect(() => {
		VPAutoService.readOptionsListHowDidYouKnowUs(UserType.PRO)
		.then((response) => {
			const optionsList = response.data.value.split(';').map((value: string) => ({
				value,
				label: value
			}));
			setOptionsListHowDidYouKnowUs([
				{ value: '', label: '' },
				...optionsList,
			]);
		}).catch((error) => {});
	}, []);
	
	const validateFields = () => {
		const newWrongFields = {
			email: !userInfo.contact.email,
			lastName: !userInfo.contact.lastName,
			firstName: !userInfo.contact.firstName,
			phone: !userInfo.contact.phone,
			function: !userInfo.contact.function,
		};
		setWrongFields(newWrongFields);
		return Object.values(newWrongFields).every((value) => !value);
	};
	
	return (
		<div
			style={{
				marginTop: 18,
				width: 277,
				height: openedPanel === 'coordinates and contact' ? '' : 20,
				background: '#FFFFFF',
				borderRadius: 10,
				position: 'relative',
				padding: 12,
				boxShadow: '0px 1px 6px #00000029',
			}}
		>
			<div
				style={{
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'space-between',
					alignItems: 'center',
					cursor: 'pointer',
				}}
				onClick={() => setOpenedPanel(openedPanel === 'coordinates and contact' ? '' : 'coordinates and contact')}
			>
				<div
					style={{
						height: 20,
						display: 'flex',
						flexDirection: 'row',
						gap: 8,
					}}
				>
					{isFirstPanelValidated ? (
						<img
							src="/images/check-2.svg"
							alt="check"
							style={{
								width: 18,
								height: 16,
							}}
						/>
					) : (
						<div style={{ width: 18 }}/>
					)}
					<div
						style={{
							fontSize: 16,
							fontWeight: 'bold',
							display: 'flex',
							alignItems: 'center',
						}}
					>
						{t('firstPanel:contact_info')}
					</div>
				</div>
				
				{openedPanel === 'coordinates and contact' ? (
					<img
						src="/images/chevron-down.svg"
						alt="chevron-down"
						style={{ width: 16, height: 16, marginRight: 5 }}
					/>
				) : (
					<img
						src="/images/chevron-right.svg"
						alt="chevron-right"
						style={{ width: 20, height: 20, marginRight: 5 }}
					/>
				)}
			</div>
			
			{openedPanel === 'coordinates and contact' && (
				<>
					<div
						style={{
							margin: '20px 10px 0px 10px',
							display: 'flex',
							flexDirection: 'column',
						}}
					>
						<TextInputMobile
							width={260}
							type="text"
							value={userInfo.contact.email}
							title={t('firstPanel:email')}
							mandatory
							disabled
							onChange={() => {}}
							wrong={wrongFields.email}
							wrongMessage={t('firstPanel:fill_this_field')}
						/>
						<div style={{ height: 18 }}></div>
						<div
							style={{
								display: 'flex',
								flexDirection: 'row',
								gap: 10,
							}}
						>
							<TextInputMobile
								width={124}
								type="text"
								value={userInfo.contact.lastName}
								placeholder="Dupont"
								title={t('firstPanel:last_name')}
								mandatory
								onChange={(e) =>
									setUserInfo({
										...userInfo,
										contact: {
											...userInfo.contact,
											lastName: toTitleCase(e.target.value),
										},
									})
								}
								wrong={wrongFields.lastName}
								wrongMessage={t('firstPanel:fill_this_field')}
							/>
							<TextInputMobile
								width={124}
								type="text"
								value={userInfo.contact.firstName}
								placeholder="Jean"
								title={t('firstPanel:first_name')}
								mandatory
								onChange={(e) =>
									setUserInfo({
										...userInfo,
										contact: {
											...userInfo.contact,
											firstName: toTitleCase(e.target.value),
										},
									})
								}
								wrong={wrongFields.firstName}
								wrongMessage={t('firstPanel:fill_this_field')}
							/>
						</div>
						<div style={{ height: 18 }}></div>
						<TextInputMobile
							width={260}
							type="text"
							value={formatPhoneNumber(userInfo.contact.phone)}
							placeholder="06 12 34 56 78"
							title={t('firstPanel:phone')}
							mandatory
							onChange={(e) =>
								setUserInfo({
									...userInfo,
									contact: {
										...userInfo.contact,
										phone: formatPhoneNumber(e.target.value),
									},
								})
							}
							wrong={wrongFields.phone}
							wrongMessage={t('firstPanel:fill_this_field')}
						/>
						<div style={{ height: 18 }}></div>
						<SelectInputMobile
							width={260}
							value={userInfo.contact.function}
							placeholder={t('firstPanel:function_placeholder')}
							options={[
								{ value: '', label: '' },
								{
									value: 'Acheteur',
									label: t('firstPanel:function_options:buyer')
								},
								{
									value: 'Administratif',
									label: t('firstPanel:function_options:admin')
								},
								{
									value: 'Chef des ventes VO',
									label: t('firstPanel:function_options:sales_manager')
								},
								{
									value: 'Comptabilité',
									label: t('firstPanel:function_options:accounting')
								},
								{
									value: 'Gérant',
									label: t('firstPanel:function_options:manager')
								},
								{
									value: 'Vendeur',
									label: t('firstPanel:function_options:seller')
								},
								{
									value: 'Autre',
									label: t('firstPanel:function_options:other')
								},
							]}
							title={t('firstPanel:function')}
							mandatory
							onChange={(e) =>
								setUserInfo({
									...userInfo,
									contact: {
										...userInfo.contact,
										function: e.target.value,
									},
								})
							}
							wrong={wrongFields.function}
							wrongMessage={t('firstPanel:fill_this_field')}
						/>
						{userInfo.company.countryCode === 'FR' && (
							<>
								<div style={{ height: 18 }}></div>
								<SelectInputMobile
									width={260}
									value={userInfo.contact.howDidYouKnowUs}
									options={optionsListHowDidYouKnowUs}
									title={t('firstPanel:how_did_you_know_us')}
									placeholder="LinkedIn"
									onChange={(e) =>
										setUserInfo({
											...userInfo,
											contact: {
												...userInfo.contact,
												howDidYouKnowUs: e.target.value,
											},
										})
									}
								/>
							</>
						)}
						<div style={{ height: 18 }}></div>
						<div
							style={{
								width: '100%',
								textAlign: 'center',
							}}
						>
							<button
								style={{
									textAlign: 'center',
									height: 28,
									width: 121,
									borderRadius: 5,
									backgroundColor: '#FF4D00',
									color: '#FFFFFF',
									border: 'none',
									fontSize: 14,
									fontWeight: 'bold',
									cursor: 'pointer',
									textTransform: 'uppercase',
								}}
								onClick={() => {
									if (validateFields()) {
										validateFirstPanel();
									}
								}}
							>
								{t('firstPanel:validate_button')}
							</button>
						</div>
					</div>
				</>
			)}
		</div>
	);
};

export default SignUpPageMobileProPanel1;
